import { queryClient } from 'v2/configs/rq-setup'
import { featureFlagsQueryKey } from 'v2/shared/utils/query-key-management'
import type { RFeatureFlags } from 'v2/types/api/auth'
import { getLocalAuth } from 'v2/utils'

// Whether this org is enrolled on the 10DLC CAMPAIGN_SVC ("api") transport, read from the
// feature-flags cache so the non-React axios interceptor can gate without a hook. Fails closed.
export const isTdlcApiTransportEnabled = (): boolean => {
  try {
    const auth = getLocalAuth()
    const flags = queryClient.getQueryData<RFeatureFlags>(
      featureFlagsQueryKey(auth?.email, auth?.organization_name),
    )
    return flags?.tdlcApiTransportEnabled === true
  } catch {
    return false
  }
}

// Applies the per-org transport decision to a request's headers. On /tdlc/ paths the flag is the
// sole authority over X-TDLC-Transport: drop every casing the caller may have supplied (HTTP headers
// are case-insensitive) and set the canonical header only when enrolled — so the gate can neither be
// forced nor bypassed. Non-/tdlc/ paths are untouched. Pure (enrolled injected) + non-generic-write
// so it's testable without the react-query singleton.
export const applyTdlcTransport = <T extends Record<string, unknown>>(
  headers: T,
  url: string | undefined,
  enabled: boolean,
): T => {
  if (!url?.includes('/tdlc/')) return headers
  const next = { ...headers } as Record<string, unknown>
  for (const key of Object.keys(next)) {
    if (key.toLowerCase() === 'x-tdlc-transport') delete next[key]
  }
  if (enabled) next['X-TDLC-Transport'] = 'api'
  return next as T
}
